export const IMAGE_MIME = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'];
export const IMAGE_WITHOUT_GIFS_MIME = IMAGE_MIME.filter(i => i !== 'image/gif');

export const VIDEO_MIME = [
  'video/3gpp',
  'video/H264',
  'video/mp4',
  'video/mpeg',
  'video/MPV',
  'video/quicktime',
  'video/raw',
];

/**
 * Mime types accepted by DA, please add per usecase entry if you do need
 * some special case but I doubt you do.
 */
export const MIME_CONFIG: Record<
  | 'forDeviationSubmit'
  | 'forDeviationStashProtect'
  | 'forEditorDropSubmit'
  | 'forDeviationAttachment'
  | 'forMediaManager'
  | 'forFilePreview',
  string[]
> = {
  forDeviationSubmit: ['*'],
  forDeviationStashProtect: [...IMAGE_WITHOUT_GIFS_MIME],
  forDeviationAttachment: ['*'],
  forEditorDropSubmit: [...IMAGE_MIME],
  forMediaManager: [...IMAGE_MIME],
  forFilePreview: [...IMAGE_MIME],
};

export const mimeTypeToPcpType = mime => {
  if (mime === 'image/gif') {
    return 'gif';
  } else if (IMAGE_MIME.includes(mime)) {
    return mime.split('/').pop();
  } else if (VIDEO_MIME.includes(mime)) {
    return 'video';
  }
  return 'unknown';
};

export const mimeTypesToDropzoneAccept = (mimes: string[] | undefined) => {
  return mimes ? Object.fromEntries(mimes.map(k => [k, []])) : undefined;
};
